
export default function About() {
  return (
    <section id="about" className="py-16 sm:py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto md:mx-0 text-center md:text-left">
          <div className="text-sm font-semibold text-[#8B5CF6] mb-4 md:mb-6 tracking-wider">
            ABOUT ONNIJOB
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-[#1A2332] leading-tight mb-8 md:mb-12">
            <span className="inline-flex items-center gap-2 md:gap-4 justify-center md:justify-start flex-wrap">
              당신의 시간을
              <span className="inline-flex w-14 h-10 md:w-20 md:h-12 rounded-full overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/38c9f0ce6db8bef7b56561f88a829120.jpg"
                  alt="행복한 알바생"
                  className="w-full h-full object-cover"
                />
              </span>
            </span>
            <br />
            가치있게 만드는
            <br />
            <span className="inline-flex items-center gap-2 md:gap-4 justify-center md:justify-start">
              스마트한
              <span className="inline-flex w-12 h-12 md:w-16 md:h-16 bg-[#8B5CF6] rounded-2xl items-center justify-center">
                <span className="text-2xl md:text-3xl">📱</span>
              </span>
              선택
            </span>
          </h2>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center md:justify-start">
            <a 
              href="https://www.onnyjob.kr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-[#8B5CF6] text-white px-6 md:px-10 py-4 md:py-5 rounded-full text-base md:text-lg font-semibold hover:bg-[#7C3AED] transition-all hover:shadow-lg whitespace-nowrap text-center"
            >
              온니잡 시작하기
            </a>
            <a 
              href="https://www.onnyjob.kr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="border-2 border-[#1A2332] text-[#1A2332] px-6 md:px-10 py-4 md:py-5 rounded-full text-base md:text-lg font-semibold hover:bg-[#1A2332] hover:text-white transition-all whitespace-nowrap text-center"
            >
              파트너사 문의
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
